import { render } from "./AddDetachementPage.vue?vue&type=template&id=bdfeb4ba&ts=true"
import script from "./AddDetachementPage.vue?vue&type=script&lang=ts"
export * from "./AddDetachementPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__